export default __webpack_public_path__ + "static/media/img-02.b22398cd.jpg";